import React from 'react';
import Image from 'next/image';
import classNames from 'classnames';

import styles from './ScreenLoader.module.scss';

function ScreenLoader({ visible = false }) {
  return (
    <div
      data-testid={'screen-loader'}
      className={classNames([styles.container, { [styles.visible]: visible }])}
      itemScope
      itemType='https://schema.org/ImageObject'
    >
      <span className={styles.loader}>
        <Image
          src={'/assets/loader.svg'}
          alt='Loading...'
          title='Loading...'
          loading='lazy'
          layout='fill'
        />
      </span>
    </div>
  );
}

export default ScreenLoader;
